import * as D from "./dialog";
import * as T from "./tabs";

type AnyComp = React.FC<any>;
export const Dialog = D.Dialog as AnyComp;
export const DialogContent = D.DialogContent as AnyComp;
export const DialogHeader = D.DialogHeader as AnyComp;
export const DialogTitle = D.DialogTitle as AnyComp;
export const DialogDescription = D.DialogDescription as AnyComp;
export const DialogFooter = D.DialogFooter as AnyComp;
export const Tabs = T.Tabs as AnyComp;
export const TabsList = T.TabsList as AnyComp;
export const TabsTrigger = T.TabsTrigger as AnyComp;
export const TabsContent = T.TabsContent as AnyComp;
